import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { Rating, RATING_ITEM_SIZE } from '../../Rating'
import Text from '../../Text'

import * as styles from './RatingListItemContent.module.css'

function RatingListItemContent({ isActive, isHovered, value }) {
  const { is_persistent: isPersistent, label, value: id } = value

  const { t } = useTranslation()

  const textClassName = classNames(styles.text, {
    [styles.hover]: isActive || isHovered,
  })

  return (
    <>
      {id === null || isPersistent ? (
        <Text isSecondary className={textClassName}>
          {t(label)}
        </Text>
      ) : (
        <Rating itemSize={RATING_ITEM_SIZE.size24} rating={id} />
      )}
    </>
  )
}

export default RatingListItemContent
